<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="header-pretitle">{{$t('Store')}}</h6>
                                <h1 class="header-title">{{$t('Waitlist')}}</h1>
                            </div>
                            <div class="col-auto">
                                <button
                                    @click="openModal({id:'productFormModal', model:productDefaults})"
                                    class="btn btn-primary"
                                >{{$t('Add product')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card" data-toggle="lists">
                    <div class="card-header">
                        <div class="row align-items-center">
                            <div class="col">
                                <!-- Search -->
                                <div class="row align-items-center">
                                    <div class="col-auto pr-0">
                                        <span class="fe fe-x text-muted" v-if="query" @click="query=null"></span>
                                        <span class="fe fe-search text-muted" v-else></span>
                                    </div>
                                    <div class="col">
                                        <input
                                            type="search"
                                            v-model="query"
                                            class="form-control form-control-flush search no-glow"
                                            :placeholder="$t('Search')"
                                        />
                                    </div>
                                </div>
                            </div>

                            <!-- brand filter -->
                            <div class="d-none d-xl-block col-auto">
                                <div class="dropdown">
                                    <b-button-group>
                                        <button
                                            class="btn btn-white"
                                            @click="brandsQuery=[];"
                                            v-if="brandsQuery.length>0"
                                        >
                                            <span class="fe fe-x"></span>
                                        </button>
                                        <b-dropdown variant="white" right :text="$t('Brands')">
                                            <div class="pt-1 pb-1 pl-3 pr-3">
                                                <b-form-checkbox
                                                    v-for="(brand, index) in brands"
                                                    :key="index"
                                                    v-model="brandsQuery"
                                                    :value="brand._id"
                                                    class="mb-3"
                                                >{{ brand.label }}</b-form-checkbox>
                                            </div>
                                        </b-dropdown>
                                    </b-button-group>
                                </div>
                            </div>

                            <!-- category filter -->
                            <div class="d-none d-xl-block col-auto">
                                <div class="dropdown">
                                    <b-button-group>
                                        <button class="btn btn-white" @click="categoriesQuery=[];" v-if="categoriesQuery.length>0">
                                            <span class="fe fe-x"></span>
                                        </button>
                                        <b-dropdown variant="white" right :text="$t('Categories')">
                                            <div class="pt-1 pb-1 pl-3 pr-3">
                                                <b-form-checkbox
                                                    v-for="(category, index) in categories"
                                                    :key="index"
                                                    v-model="categoriesQuery"
                                                    :value="category._id"
                                                    class="mb-3"
                                                >{{ category.label }}</b-form-checkbox>
                                            </div>
                                        </b-dropdown>
                                    </b-button-group>
                                </div>
                            </div>

                            <!-- filter button -->
                            <div class="col-auto d-xl-none">
                                <b-button @click="openModal({id:'productsFilterModal'})" variant="white" size="md">
                                    <i class="fe fe-filter"></i>
                                </b-button>
                            </div>

                        </div>
                        <!-- / .row -->
                    </div>

                    <simple-table
                        :data="items"
                        :onSort="setSort"
                        :loading="areProductsLoading"
                        :edit="edit"
                        :deleteItem="deleteItem"
                        :columns="columns"
                        :sort="sort"
                    ></simple-table>
                </div>
                <div class="mt-3 text-center" v-if="totalRows > perPage">
                    <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" />
                </div>
            </div>
        </div>
        <product-form-modal id="productFormModal" :data="model"></product-form-modal>

        <mobile-filters-modal id="productsFilterModal">
            <!-- brand filter -->
            <div class="col-12 mb-3">
                <div class="dropdown">
                    <b-button-group>
                        <button
                            class="btn btn-white"
                            @click="brandsQuery=[];"
                            v-if="brandsQuery.length>0"
                        >
                            <span class="fe fe-x"></span>
                        </button>
                        <b-dropdown variant="white" right :text="$t('Brands')">
                            <div class="pt-1 pb-1 pl-3 pr-3">
                                <b-form-checkbox
                                    v-for="(brand, index) in brands"
                                    :key="index"
                                    v-model="brandsQuery"
                                    :value="brand._id"
                                    class="mb-3"
                                >{{ brand.label }}</b-form-checkbox>
                            </div>
                        </b-dropdown>
                    </b-button-group>
                </div>
            </div>

            <!-- category filter -->
            <div class="col-12 mb-3">
                <div class="dropdown">
                    <b-button-group>
                        <button class="btn btn-white" @click="categoriesQuery=[];" v-if="categoriesQuery.length>0">
                            <span class="fe fe-x"></span>
                        </button>
                        <b-dropdown variant="white" right :text="$t('Categories')">
                            <div class="pt-1 pb-1 pl-3 pr-3">
                                <b-form-checkbox
                                    v-for="(category, index) in categories"
                                    :key="index"
                                    v-model="categoriesQuery"
                                    :value="category._id"
                                    class="mb-3"
                                >{{ category.label }}</b-form-checkbox>
                            </div>
                        </b-dropdown>
                    </b-button-group>
                </div>
            </div>
        </mobile-filters-modal>

    </div>
</template>

<script>
import ProductFormModal from './ProductFormModal.vue'
import SimpleTable from '@/components/SimpleTable.vue'
import { modalMixins } from '@/mixins/modal.js'
import { mapActions, mapGetters, mapState } from 'vuex';
import debounce from 'lodash/debounce';
import currency from '@/filters/currency.js';
import mobileFiltersModal from "@/components/mobileFiltersModal";



export default {
    mixins: [modalMixins],
    components: {
        SimpleTable,
        ProductFormModal,
        mobileFiltersModal
    },
    data() {
        return {
            // items: [],
            chartRaw: [],
            brandChartRaw: [],
            productDefaults: {
                avatar_id: null,
                avatar: {},
                enableStock: true,
                price: {},
                enablePricing: true,
                enableSupply: true,
                stock: {},
                supplies: [],

            },
            date: null,
            query: null,
            categoriesQuery: [],
            brandsQuery: [],
            params: {
                query: {
                    $limit: 10000,
                    inWaitlist: true,
                    $sort: 'createdAt',
                }
            },
            currentPage: 1,
            perPage: 100,
            totalRows: 0,
            sort: 'createdAt',
            order: -1,
            model: {},
            errors: {},
            columns: [
                {
                    label: 'Image',
                    name: 'avatar',
                    image: true,
                    width: 50,
                    field: (item) => {
                        if (item.avatar)
                            return item.avatar.preview;
                    }
                },
                {
                    label: 'Name',
                    name: 'label',
                    sortable: true,
                    link(item) {
                        return { name: 'materials.product', params: { productId: item._id } };
                    },
                    subtitle: (item) => {
                        let subtitle = '';
                        if (item.category)
                            subtitle += item.category.label;
                        if (item.brand)
                            subtitle += '  ' + item.brand.label;

                        return subtitle;

                    },

                },

                {
                    label: 'Stock',
                    name: 'stock',

                    field: (item) => {
                        if (item.stock) {

                            let measurement = (item.measurement) ? '' + item.measurement : '';
                            // return (item.stock.quantity ? item.stock.quantity : 'N/A') + ' ' + measurement;

                            if (item.stock.quantity) {
                                return item.stock.initialQuantity + '<span class="text-muted">/' + item.stock.quantity + '</span> ' + measurement;
                            } else {
                                return 'N/A'
                            }

                        }
                    },
                },
                {
                    label: 'Minimum',
                    name: 'minimum',
                    field(item) {
                        let measurement = (item.measurement) ? '' + item.measurement : '';
                        return (item.minimum) ? item.minimum + ' ' + measurement : 'N/A';
                    }
                },
                {
                    name: 'Supplier',
                    label: 'Supplier',
                    field(item) {
                        if (item.supplyId) {
                            let supplier = item.supply.supplier;
                            return supplier.label;
                        } else {
                            return 'N/A'
                        }

                    },
                    subtitle(item) {
                        if (item.supplyId) {
                            let supplier = item.supply.supplier;
                            return supplier.contacts.primaryPhone;
                        }
                    }
                }

            ],
        };
    },
    computed: {
        ...mapState('products', { areProductsLoading: 'isFindPending' }),
        ...mapGetters('products', {
            findProductsInStore: 'find'
        }),
        ...mapGetters('categories', {
            findCategoriesInStore: 'find',
            getCategoryById: 'get'
        }),
        ...mapGetters('brands', {
            findBrandsInStore: 'find',
            getBrandById: 'get'
        }),
        ...mapGetters('suppliers', {
            getSupplierById: 'get'
        }),

        items() {
            let items = this.findProductsInStore(this.params).data;
            items.map(item => {
                item.category = this.getCategoryById(item.categoryId);
                item.brand = this.getBrandById(item.brandId);
                if (!item.price) item.price = {};
                if (!item.stock) item.stock = {};
            })
            return items;
        },
        categories() {
            return this.findCategoriesInStore().data;
        },
        brands() {
            return this.findBrandsInStore().data;
        },
        suppliers() {
            return this.findSuplliersInStore().data;
        },
        brandData: {
            get() {
                return this.brandChartRaw;
            },
            set(values) {
                values.map(item => {
                    let brand = this.getBrandById(item._id);
                    if (!brand) return;
                    item._id = brand.label;

                });
                this.brandChartRaw = values;
            }
        },
        chartData: {
            get() {
                return this.chartRaw;
            },
            set(values) {
                values.map(item => {
                    item._id = this.getCategoryById(item._id).label;
                });
                this.chartRaw = values;
            }
        }
    },
    watch: {
        query: debounce(function (newVal) {
            if (newVal) {
                // params.query.$search = this.query;
                this.params.query.$or = [
                    { label: { $regex: this.query, $options: "i" } },
                ];
            } else {
                delete this.params.query.$or;
            }
            this.fetchItems();
        }, 400),
        currentPage: debounce(function (newVal) {

        }, 400),
        categoriesQuery: debounce(function (newVal) {
            if (newVal.length > 0) {
                this.params.query.categoryId = { $in: newVal };
            } else {
                delete this.params.query.categoryId;
            }
            this.fetchItems();
        }, 400),

        brandsQuery: debounce(function (newVal) {
            if (newVal.length > 0) {
                this.params.query.brandId = { $in: newVal };
            } else {
                delete this.params.query.brandId;
            }
            this.fetchItems();
        }, 400),

    },
    created() {

        Promise.all([this.fetchBrands(), this.fetchCategories()]).then(items => {
            this.fetchSupliers();
            this.fetchItems().then(data => {
                console.log('data', data);
            });
        });

    },
    methods: {
        ...mapActions('products', ['find', 'remove', 'create', 'patch']),
        ...mapActions('categories', { fetchCategories: 'find' }),
        ...mapActions('brands', { fetchBrands: 'find' }),
        ...mapActions('suppliers', { fetchSupliers: 'find' }),
        ...mapActions('supplies', { fetchSupplyById: 'find' }),

        setSort(field, order) {
            this.sort = field;
            this.order = order;
            this.fetchItems();
        },
        edit(item) {
            this.openModal({ id: 'productFormModal', model: item })

        },
        deleteItem(item) {
            this.remove(item._id).then(result => {
                this.$toasted.global.success({
                    message: this.$t('Product has been removed')
                });
            });
        },


        fetchItems() {

            return this.find(this.params).then(result => {
                this.chartData = result.meta;
                this.brandData = result.brandChart;
                this.totalRows = result.total;
            });
        },
    }
}
</script>
